module.exports = __webpack_public_path__ + "img/attologo-small.d71ae5f2.png";